import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

export default function SignupPage() {
  const { setUser, csrfToken } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const { data } = await axios.post('/auth/signup', form, {
        headers: { 'X-CSRF-Token': csrfToken }
      });
      setUser(data.user);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    } finally {
      setBusy(false);
    }
  }

  function googleSignup() {
    window.location.href = process.env.REACT_APP_API_URL + '/auth/google';
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <h1 className="h4 mb-3 text-center">Sign Up</h1>
              {error && <div className="alert alert-danger">{error}</div>}

              <button className="btn btn-outline-dark w-100 mb-3" onClick={googleSignup}>
                <img alt="Google" src="https://www.gstatic.com/images/branding/product/1x/googleg_24dp.png" className="me-2" />
                Sign up / Login with Google
              </button>

              <div className="text-center text-muted my-2">or</div>

              <form onSubmit={onSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-control" required
                    value={form.name}
                    onChange={e => setForm({ ...form, name: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" required
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input type="password" className="form-control" required
                    placeholder="At least 8 characters, including uppercase/lowercase letters, numbers, and symbols"
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })} />
                </div>
                <button className="btn btn-primary w-100" disabled={busy}>
                  {busy ? 'Signing up...' : 'Sign Up'}
                </button>
              </form>

              <div className="mt-3 text-center">
                <span>Already have an account? </span>
                <Link to="/login">Log in</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
